import React from 'react';
import axios from 'axios';
import { Card, Button, Avatar,Modal,Form, Input,Select,Spin,Image,Result,DatePicker, message,Switch,Tabs } from 'antd';
import AccountUpdateForm from '../components/AccountUpdateForm'
import { UserOutlined,LoadingOutlined } from '@ant-design/icons';
import { PlusOutlined } from '@ant-design/icons';
import { Drawer,Divider } from 'antd';
import * as serverconfig from '../serverconn'
import {
  Col,
  Row,
} from 'reactstrap';
import PhoneInput from 'react-phone-number-input'

import CompanyProfile_autosettings from './companyProfile_autosettings'
import MemberSubaccountLedgerSettings from './MemberSubaccountLedgerSettings'


var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const { Option } = Select;
const { Meta } = Card;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;
const { TabPane } = Tabs;
const dateFormat = 'DD/MM/YYYY';

var token= ''
var sacco= ''
var bizuserid= ''

class CompanyProfile extends React.Component{

    state={
        profile: {},
        datarequested:true,
        profileTabKey: '001',
        sacco_name:'',
        sacco_logo:null,
        sacco_logo_file:'',
        company_email:'',
        RegisteredPhoneNumber1:'',
        RegisteredPhoneNumber2:'',
        RegisteredPhoneNumber3:'',

        box_number:'',
        address:'',
        sharevalue:0,
        website:'',
        loanrepaymentalertdays:0,
        automatedloanreminders:false,
        allowaccountmonthlyemailstatements:false,
        email_statements:false,

        automated_accounts:false,
        account_concstring:'',
        last_accountnmumber:'',
        automated_transaction_date:false,

        allow_transaction_editing:false,
        showeditablewithdrawcharge:false,

        companyaccounts:[],


        account_tocreditsavings_ondeposit:0,
        account_tocreditshares_ondeposit:0,
        account_tocreditfixeddeposit_ondeposit:0,

        account_todebit_onwithdraw:0,
        account_tocredit_onwithdrawcharge:0,
        account_tocredit_onwithdrawbankcharge:0,


        account_tocredit_onossavings_interest_payable:0,
        account_tocredit_fixeddepositsavings_interest_payable:0,
        account_tocredit_fixeddepositsavings_interest_expense:0,
        account_tocredit_onossavings_interest_expense:0,

        account_tocredit_onsavingsreserve:0,
        allow_transaction_reversal:false,
        savings_interest_active:false,


        account_fordividend_payable:0,
        account_for_retained_earnings:0,
        account_for_dividend_taxes:0,

        account_for_savingsinterest_taxes:0,
        account_for_fixeddepositinterest_taxes:0,
        usesms:false,


        nssf_enabled:false,
        nssfstaffpercentage:0,
        nssfcompanypercentage:0,
        nssfliabilityaccount:0,
        salary_expenseaccount:0,
        roundoffvalue:0,

        account_for_mobilemoneycollection_debiting:0,
        account_for_appcollection_debiting:0,
        members_portal_active:false,
        message:'',
        datasubmittedsuccessfully:false,
        defaultaccount_for_officecollection_debiting:0,
        defaultaccount_for_savingswithdraw_crediting:0,
        defaultaccount_for_loanissuance_crediting:0,


        automated_savingstransfer_toloan:false,
        automated_savingstransfer_toloan_interestprinciple_priority:'',

        accumulated_dividends_active:false,
        accumulated_dividends_crediting_account:0,

        default_report_currency:'',
        currencies: [],
        send_member_welcome_message:false,

        //date entry cap
        dataentry_date_cap:''

    }


    componentDidMount(){
      if(localStorage.getItem("token")){
         token= localStorage.getItem("token")
      }else{
         token= ''
      }

      if(localStorage.getItem("sacco")){
        sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
        bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
     
     }else{
        sacco= ''
        bizuserid= ''
     }


      axios.defaults.headers={
        "Content-Type":"application/json",
        Authorization:`Token ${token}`
      }

      const hashTab = (window.location.hash || '').replace('#', '');
      if (hashTab === '003' || hashTab === 'ledger-map') {
        this.setState({ profileTabKey: '003' });
      }

        axios.get(`${serverconfig.backendserverurl}/api/saccosedit/${sacco}`)
        .then(res => {  
            this.setState({
              profile: res.data
            })
            console.log(res.data)

            this.setState({sacco_name:res.data.sacco_name})
            this.setState({company_email:res.data.company_email})
            this.setState({RegisteredPhoneNumber1:res.data.RegisteredPhoneNumber1})
            this.setState({RegisteredPhoneNumber2:res.data.RegisteredPhoneNumber2})
            this.setState({RegisteredPhoneNumber3:res.data.RegisteredPhoneNumber3})

            this.setState({box_number:res.data.box_number})
            this.setState({address:res.data.address})
            this.setState({sharevalue:res.data.sharevalue})
            this.setState({website:res.data.website})

            this.setState({sacco_logo_file:res.data.sacco_logo})

            this.setState({loanrepaymentalertdays:res.data.loanrepaymentalertdays})
            this.setState({automatedloanreminders:res.data.automatedloanreminders})
            this.setState({allowaccountmonthlyemailstatements:res.data.allowaccountmonthlyemailstatements})
            this.setState({email_statements:res.data.email_statements})

            this.setState({automated_accounts:res.data.automated_accounts})
            this.setState({account_concstring:res.data.account_concstring})
            this.setState({last_accountnmumber:res.data.last_accountnmumber})
            this.setState({automated_transaction_date:res.data.automated_transaction_date})
            this.setState({allow_transaction_editing:res.data.allow_transaction_editing})

            this.setState({showeditablewithdrawcharge:res.data.showeditablewithdrawcharge})



            this.setState({account_tocreditsavings_ondeposit:res.data.account_tocreditsavings_ondeposit==null?0:res.data.account_tocreditsavings_ondeposit})
            this.setState({account_tocreditshares_ondeposit:res.data.account_tocreditshares_ondeposit==null?0:res.data.account_tocreditshares_ondeposit})
            this.setState({account_tocreditfixeddeposit_ondeposit:res.data.account_tocreditfixeddeposit_ondeposit==null?0:res.data.account_tocreditfixeddeposit_ondeposit})
           
            this.setState({account_todebit_onwithdraw:res.data.account_todebit_onwithdraw==null?0:res.data.account_todebit_onwithdraw})
            this.setState({account_tocredit_onwithdrawcharge:res.data.account_tocredit_onwithdrawcharge==null?0:res.data.account_tocredit_onwithdrawcharge})
            this.setState({account_tocredit_onwithdrawbankcharge:res.data.account_tocredit_onwithdrawbankcharge==null?0:res.data.account_tocredit_onwithdrawbankcharge})
            


            this.setState({account_tocredit_onsavingsreserve:res.data.account_tocredit_onsavingsreserve==null?0:res.data.account_tocredit_onsavingsreserve})
            this.setState({allow_transaction_reversal:res.data.allow_transaction_reversal})
            this.setState({savings_interest_active:res.data.savings_interest_active})

            this.setState({account_tocredit_onossavings_interest_payable:res.data.account_tocredit_onossavings_interest_payable==null?0:res.data.account_tocredit_onossavings_interest_payable})
            this.setState({account_tocredit_onossavings_interest_expense:res.data.account_tocredit_onossavings_interest_expense==null?0:res.data.account_tocredit_onossavings_interest_expense})

            this.setState({account_tocredit_fixeddepositsavings_interest_payable:res.data.account_tocredit_fixeddepositsavings_interest_payable==null?0:res.data.account_tocredit_fixeddepositsavings_interest_payable})
            this.setState({account_tocredit_fixeddepositsavings_interest_expense:res.data.account_tocredit_fixeddepositsavings_interest_expense==null?0:res.data.account_tocredit_fixeddepositsavings_interest_expense})

            this.setState({account_fordividend_payable:res.data.account_fordividend_payable==null?0:res.data.account_fordividend_payable})
            this.setState({account_for_retained_earnings:res.data.account_for_retained_earnings==null?0:res.data.account_for_retained_earnings})
            this.setState({account_for_dividend_taxes:res.data.account_for_dividend_taxes==null?0:res.data.account_for_dividend_taxes})

            this.setState({account_for_fixeddepositinterest_taxes:res.data.account_for_fixeddepositinterest_taxes==null?0:res.data.account_for_fixeddepositinterest_taxes})
            this.setState({account_for_savingsinterest_taxes:res.data.account_for_savingsinterest_taxes==null?0:res.data.account_for_savingsinterest_taxes})
            this.setState({defaultaccount_for_officecollection_debiting:res.data.defaultaccount_for_officecollection_debiting==null?0:res.data.defaultaccount_for_officecollection_debiting})
            this.setState({defaultaccount_for_savingswithdraw_crediting:res.data.defaultaccount_for_savingswithdraw_crediting==null?0:res.data.defaultaccount_for_savingswithdraw_crediting})
            this.setState({defaultaccount_for_loanissuance_crediting:res.data.defaultaccount_for_loanissuance_crediting==null?0:res.data.defaultaccount_for_loanissuance_crediting})


            
            
            this.setState({usesms:res.data.usesms})

            this.setState({nssf_enabled:res.data.nssf_enabled})

            this.setState({nssfstaffpercentage:res.data.nssfstaffpercentage==null?0:res.data.nssfstaffpercentage})
            this.setState({nssfcompanypercentage:res.data.nssfcompanypercentage==null?0:res.data.nssfcompanypercentage})
            this.setState({nssfliabilityaccount:res.data.nssfliabilityaccount==null?0:res.data.nssfliabilityaccount})
            this.setState({salary_expenseaccount:res.data.salary_expenseaccount==null?0:res.data.salary_expenseaccount})

            this.setState({account_for_mobilemoneycollection_debiting:res.data.account_for_mobilemoneycollection_debiting==null?0:res.data.account_for_mobilemoneycollection_debiting})
            this.setState({account_for_appcollection_debiting:res.data.account_for_appcollection_debiting==null?0:res.data.account_for_appcollection_debiting})

            this.setState({roundoffvalue:res.data.roundoffvalue})

            this.setState({members_portal_active:res.data.members_portal_active})


            this.setState({automated_savingstransfer_toloan:res.data.automated_savingstransfer_toloan})
            this.setState({automated_savingstransfer_toloan_interestprinciple_priority:res.data.automated_savingstransfer_toloan_interestprinciple_priority})


            this.setState({accumulated_dividends_active:res.data.accumulated_dividends_active})
           // this.setState({accumulated_dividends_crediting_account:res.data.accumulated_dividends_crediting_account})

            this.setState({accumulated_dividends_crediting_account:res.data.accumulated_dividends_crediting_account==null?0:res.data.accumulated_dividends_crediting_account})
            this.setState({default_report_currency:res.data.default_report_currency})
            this.setState({send_member_welcome_message:res.data.send_member_welcome_message})

            //data entry cap date
            this.setState({dataentry_date_cap:res.data.dataentry_date_cap})


           /// this.setState({datarequested:false})
        })


        axios.get(serverconfig.backendserverurl+`/api/companyaccounts/?sacco=${sacco}`)
        .then(res => {
            this.setState({
                companyaccounts:res.data
            })
        })

        axios.get(serverconfig.backendserverurl+`/api/currencies/?sacco=${sacco}`)
        .then(res => {
            this.setState({
                currencies:res.data
            })
            this.setState({datarequested:false})
    
        })


    }

    handleFormSubmit=(event) =>{
      this.setState({datarequested:true})
    
      let form_data = new FormData();
  
      this.state.sacco_logo==null?
      console.log("No sacco_logo file")
      :
      form_data.append('sacco_logo', this.state.sacco_logo,this.state.sacco_logo?this.state.sacco_logo.name:"");
  
      form_data.append('sacco_name', this.state.sacco_name);
      form_data.append('company_email', this.state.company_email);
      form_data.append('RegisteredPhoneNumber1', this.state.RegisteredPhoneNumber1);
      form_data.append('RegisteredPhoneNumber2', this.state.RegisteredPhoneNumber2);
      form_data.append('RegisteredPhoneNumber3', this.state.RegisteredPhoneNumber3);

      form_data.append('box_number', this.state.box_number);
      form_data.append('address', this.state.address);
      form_data.append('sharevalue', this.state.sharevalue);
      form_data.append('website', this.state.website);

      form_data.append('loanrepaymentalertdays', this.state.loanrepaymentalertdays);
      form_data.append('automatedloanreminders', this.state.automatedloanreminders);
      form_data.append('allowaccountmonthlyemailstatements', this.state.allowaccountmonthlyemailstatements);
      form_data.append('email_statements', this.state.email_statements);

      form_data.append('automated_accounts', this.state.automated_accounts);
      form_data.append('account_concstring', this.state.account_concstring);
      form_data.append('last_accountnmumber', this.state.last_accountnmumber);
      form_data.append('automated_transaction_date', this.state.automated_transaction_date);
      form_data.append('allow_transaction_editing', this.state.allow_transaction_editing);

      form_data.append('showeditablewithdrawcharge', this.state.showeditablewithdrawcharge);


      form_data.append('account_tocreditsavings_ondeposit', this.state.account_tocreditsavings_ondeposit);
      form_data.append('account_tocreditshares_ondeposit', this.state.account_tocreditshares_ondeposit);
      form_data.append('account_tocreditfixeddeposit_ondeposit', this.state.account_tocreditfixeddeposit_ondeposit);
     
      form_data.append('account_todebit_onwithdraw', this.state.account_todebit_onwithdraw);
      form_data.append('account_tocredit_onwithdrawcharge', this.state.account_tocredit_onwithdrawcharge);
      form_data.append('account_tocredit_onwithdrawbankcharge', this.state.account_tocredit_onwithdrawbankcharge);
      form_data.append('account_tocredit_onsavingsreserve', this.state.account_tocredit_onsavingsreserve);



      form_data.append('allow_transaction_reversal', this.state.allow_transaction_reversal);
      form_data.append('savings_interest_active', this.state.savings_interest_active);
      form_data.append('account_tocredit_onossavings_interest_payable', this.state.account_tocredit_onossavings_interest_payable);
      form_data.append('account_tocredit_onossavings_interest_expense', this.state.account_tocredit_onossavings_interest_expense);

      form_data.append('account_tocredit_fixeddepositsavings_interest_payable', this.state.account_tocredit_fixeddepositsavings_interest_payable);
      form_data.append('account_tocredit_fixeddepositsavings_interest_expense', this.state.account_tocredit_fixeddepositsavings_interest_expense);

      form_data.append('account_fordividend_payable', this.state.account_fordividend_payable);
      form_data.append('account_for_retained_earnings', this.state.account_for_retained_earnings);
      form_data.append('account_for_dividend_taxes', this.state.account_for_dividend_taxes);

      form_data.append('account_for_fixeddepositinterest_taxes', this.state.account_for_fixeddepositinterest_taxes);
      form_data.append('account_for_savingsinterest_taxes', this.state.account_for_savingsinterest_taxes);
     
      form_data.append('account_for_mobilemoneycollection_debiting', this.state.account_for_mobilemoneycollection_debiting);
      form_data.append('account_for_appcollection_debiting', this.state.account_for_appcollection_debiting);
      form_data.append('defaultaccount_for_officecollection_debiting', this.state.defaultaccount_for_officecollection_debiting);
      form_data.append('defaultaccount_for_savingswithdraw_crediting', this.state.defaultaccount_for_savingswithdraw_crediting);
      form_data.append('defaultaccount_for_loanissuance_crediting', this.state.defaultaccount_for_loanissuance_crediting);

      
      form_data.append('usesms', this.state.usesms);
      form_data.append('nssf_enabled', this.state.nssf_enabled);

      form_data.append('nssfstaffpercentage', this.state.nssfstaffpercentage);
      form_data.append('nssfcompanypercentage', this.state.nssfcompanypercentage);
      form_data.append('nssfliabilityaccount', this.state.nssfliabilityaccount);
      form_data.append('salary_expenseaccount', this.state.salary_expenseaccount);

      form_data.append('roundoffvalue', this.state.roundoffvalue);
      form_data.append('members_portal_active', this.state.members_portal_active);


      form_data.append('automated_savingstransfer_toloan', this.state.automated_savingstransfer_toloan);
      form_data.append('automated_savingstransfer_toloan_interestprinciple_priority', this.state.automated_savingstransfer_toloan_interestprinciple_priority);

      form_data.append('accumulated_dividends_active', this.state.accumulated_dividends_active);
      form_data.append('accumulated_dividends_crediting_account', this.state.accumulated_dividends_crediting_account);
      form_data.append('default_report_currency', this.state.default_report_currency);
      form_data.append('send_member_welcome_message', this.state.send_member_welcome_message);

      form_data.append('dataentry_date_cap', this.state.dataentry_date_cap);
      form_data.append('sacco', sacco);

      axios.post(`${serverconfig.backendserverurl}/customqueries/editprofile`,form_data, {
        headers: {
        'content-type': 'multipart/form-data'
        }
      })
      .then(res =>{
        console.log(res.data.message)
        this.setState({datarequested:false})
        this.setState({message:res.data.message})
        this.setState({datasubmittedsuccessfully:true})

      })       
     
      }


    render(){

      if(this.state.datarequested===true){
        return(
          <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin size="large">
              <div className="content">
                <h3>Pisacco</h3>
              </div>
               </Spin> 
               
               
                </div>
        )
  
      }else{
        return(
          <div>

            <Tabs
              activeKey={this.state.profileTabKey}
              onChange={(key) => this.setState({ profileTabKey: key })}
            >
                <TabPane tab="Main profile settings" key="001" >

                {
            this.state.datasubmittedsuccessfully===true?
            <Card>
            <Result
            status="success"
            subTitle={this.state.message}
            extra={[
              <Button  type='primary' onClick={()=>{window.location.reload(false)}}>Finish</Button>,
            ]}
            />
            </Card>
            :
            <Card 
            style={{padding:10}}
            hoverable>
          <Form
                onFinish={(event) => this.handleFormSubmit(event)}
                >
                   <h3>Main profile settings</h3>

                    <FormItem label="Company Name">
                        <Input name="sacco_name"  placeholder="Company name." value={this.state.sacco_name} onChange={(val)=>{this.setState({sacco_name:val.target.value})}} />
                    </FormItem>

                    <FormItem label="Address">
                        <Input placeholder="Address" value={this.state.address} onChange={(val)=>{this.setState({address:val.target.value})}} />
                    </FormItem>

                    <div style={{display:'flex',flexDirection:'row'}}>

                    <FormItem label="Logo">
                        <Input name="companylogo" type="file" accept="image/png, image/jpeg" placeholder="Company logo" 
                        
                        onChange={(e) =>{
                        if(e.target.files[0]){
                          this.setState({
                            sacco_logo_file: URL.createObjectURL(e.target.files[0])
                          })
                        }
                        this.setState({ sacco_logo: e.target.files[0]})

                        } }/>
                    </FormItem> 

                    {this.state.sacco_logo!=null || this.state.sacco_logo_file!=""?
                      <Image
                      width={50}
                      height={50}
                      src={this.state.sacco_logo_file}    
                      />
                      :
                      null
                      }

                    </div>

                    <FormItem label="Company Email">
                        <Input name="companyemail" type="email"  placeholder="company@email.com" value={this.state.company_email} onChange={(val)=>{this.setState({company_email:val.target.value})}} />
                    </FormItem> 

    
                    <FormItem label="Phone Number one">
                    <PhoneInput
                            countrySelectProps={{ unicodeFlags: true }}
                            defaultCountry="UG"
                            placeholder="Enter phone number"
                            value={this.state.RegisteredPhoneNumber1} onChange={(val)=>{this.setState({RegisteredPhoneNumber1:val})}}/>
                    </FormItem> 


                    <FormItem label="Phone Number two">
                    <PhoneInput
                            countrySelectProps={{ unicodeFlags: true }}
                            defaultCountry="UG"
                            placeholder="Enter phone number"
                            value={this.state.RegisteredPhoneNumber2} onChange={(val)=>{this.setState({RegisteredPhoneNumber2:val})}}/>
                    </FormItem>

                    <FormItem label="Phone Number three">
                    <PhoneInput
                            countrySelectProps={{ unicodeFlags: true }}
                            defaultCountry="UG"
                            placeholder="Enter phone number"
                            value={this.state.RegisteredPhoneNumber3} onChange={(val)=>{this.setState({RegisteredPhoneNumber3:val})}}/>
                    </FormItem>
    
                    <FormItem label="Box number">
                        <Input placeholder="Box number here" value={this.state.box_number} onChange={(val)=>{this.setState({box_number:val.target.value})}} />
                    </FormItem>

                    <FormItem label="Website">
                        <Input name="website"   placeholder="www.company.com" value={this.state.website} onChange={(val)=>{this.setState({website:val.target.value})}} />
                    </FormItem> 

                    <FormItem label="Share value">
                        <Input type='number' placeholder="Share value" value={this.state.sharevalue} onChange={(val)=>{this.setState({sharevalue:val.target.value})}} />
                    </FormItem>

                    <FormItem label="Roundoff value">
                        <Input type='number' placeholder="round off value" value={this.state.roundoffvalue} onChange={(val)=>{this.setState({roundoffvalue:val.target.value})}} />
                    </FormItem>

                    <FormItem name="allowaccountmonthlyemailstatements" label="Allowaccountmonthlyemailstatements" >
                            <Switch
                                checked={this.state.allowaccountmonthlyemailstatements}
                                onChange={val=>{this.setState({allowaccountmonthlyemailstatements:!this.state.allowaccountmonthlyemailstatements})}}
                                checkedChildren="ON"
                                unCheckedChildren="OFF"
                                />
                            
                    </FormItem>

                    <FormItem name="email_statements" label="Email_statements" >
                            <Switch
                                checked={this.state.email_statements}
                                onChange={val=>{this.setState({email_statements:!this.state.email_statements})}}
                                checkedChildren="ON"
                                unCheckedChildren="OFF"
                                />
                            
                    </FormItem>

                  
                    <FormItem name="automatedloanreminders" label="Automated sms loan reminders" >
                            <Switch
                                checked={this.state.automatedloanreminders}
                                onChange={val=>{this.setState({automatedloanreminders:!this.state.automatedloanreminders})}}
                                checkedChildren="ON"
                                unCheckedChildren="OFF"
                                />
                    </FormItem>

                    <FormItem name="allow_transaction_reversal" label="Allow transaction reversal" >
                            <Switch
                                checked={this.state.allow_transaction_reversal}
                                onChange={val=>{this.setState({allow_transaction_reversal:!this.state.automatedloanreminders})}}
                                checkedChildren="ON"
                                unCheckedChildren="OFF"
                                />
                    </FormItem>


                    <FormItem name="savings_interest_active" label="savings interest active?" >
                            <Switch
                                checked={this.state.savings_interest_active}
                                onChange={val=>{this.setState({savings_interest_active:!this.state.savings_interest_active})}}
                                checkedChildren="ON"
                                unCheckedChildren="OFF"
                                />
                    </FormItem>


                    <FormItem label="Loan repayment alert days">
                        <Input type='number' placeholder="Days" value={this.state.loanrepaymentalertdays} onChange={(val)=>{this.setState({loanrepaymentalertdays:val.target.value})}} />
                    </FormItem>

                    <FormItem name="automated_accounts" label="Automated account numbers" >
                            <Switch
                                checked={this.state.automated_accounts}
                                onChange={val=>{this.setState({automated_accounts:!this.state.automated_accounts})}}
                                checkedChildren="ON"
                                unCheckedChildren="OFF"
                                />
                    </FormItem>

                    <FormItem label="Automated account concatination string">
                        <Input name="account_concstring"   placeholder="Account concatination string" value={this.state.account_concstring} onChange={(val)=>{this.setState({account_concstring:val.target.value})}} />
                    </FormItem> 

                    <FormItem label="Last account number">
                        <Input name="last_accountnmumber"   placeholder="Last account number" value={this.state.last_accountnmumber} onChange={(val)=>{this.setState({last_accountnmumber:val.target.value})}} />
                    </FormItem> 

                    <FormItem name="automated_transaction_date" label="Automated transaction date" >
                            <Switch
                                checked={this.state.automated_transaction_date}
                                onChange={val=>{this.setState({automated_transaction_date:!this.state.automated_transaction_date})}}
                                checkedChildren="ON"
                                unCheckedChildren="OFF"
                                />
                    </FormItem>

                 

                    <FormItem name="showeditablewithdrawcharge" label="Editable withdraw charge" >
                        <Switch
                            checked={this.state.showeditablewithdrawcharge}
                            onChange={val=>{this.setState({showeditablewithdrawcharge:!this.state.showeditablewithdrawcharge})}}
                            checkedChildren="ON"
                            unCheckedChildren="OFF"
                            />
                    </FormItem>


           
                    <h3>Ledger profile settings (Deposit)</h3>

                    <FormItem label={"Account_tocreditsavings_ondeposit"}>
                      <Select 
                      placeholder="Account" 
                      style={{  }} 
                      value={this.state.account_tocreditsavings_ondeposit}
                      onChange={(val)=>{this.setState({account_tocreditsavings_ondeposit:val})}} 
                      showSearch
                      optionFilterProp="children"
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      onSearch={this.onSearch}                    
                      >
                        {this.state.companyaccounts.map(
                          (accnt)=>(
                            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
                          ))}
                      </Select>
                  </FormItem>

                  <FormItem label={"Account_tocreditshares_ondeposit"}>
                      <Select 
                      placeholder="Account" 
                      style={{  }} 
                      value={this.state.account_tocreditshares_ondeposit}
                      onChange={(val)=>{this.setState({account_tocreditshares_ondeposit:val})}} 
                      showSearch
                      optionFilterProp="children"
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      onSearch={this.onSearch}                    
                      >
                        {this.state.companyaccounts.map(
                          (accnt)=>(
                            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
                          ))}
                      </Select>
                  </FormItem>


                  <FormItem label={"account_tocreditfixeddeposit_ondeposit"}>
                      <Select 
                      placeholder="Account" 
                      style={{  }} 
                      value={this.state.account_tocreditfixeddeposit_ondeposit}
                      onChange={(val)=>{this.setState({account_tocreditfixeddeposit_ondeposit:val})}} 
                      showSearch
                      optionFilterProp="children"
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      onSearch={this.onSearch}                    
                      >
                        {this.state.companyaccounts.map(
                          (accnt)=>(
                            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
                          ))}
                      </Select>
                  </FormItem>



                  <FormItem label={"account_tocredit_onsavingsreserve"}>
                      <Select 
                      placeholder="Account" 
                      style={{  }} 
                      value={this.state.account_tocredit_onsavingsreserve}
                      onChange={(val)=>{this.setState({account_tocredit_onsavingsreserve:val})}} 
                      showSearch
                      optionFilterProp="children"
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      onSearch={this.onSearch}                    
                      >
                        {this.state.companyaccounts.map(
                          (accnt)=>(
                            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
                          ))}
                      </Select>
                  </FormItem>



                  <FormItem label={"Default account for officecollection debiting"}>
                      <Select 
                      placeholder="Account" 
                      style={{  }} 
                      value={this.state.defaultaccount_for_officecollection_debiting}
                      onChange={(val)=>{this.setState({defaultaccount_for_officecollection_debiting:val})}} 
                      showSearch
                      optionFilterProp="children"
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      onSearch={this.onSearch}                    
                      >
                        {this.state.companyaccounts.map(
                          (accnt)=>(
                            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
                          ))}
                      </Select>
                  </FormItem>



                  


                  <h3>Ledger profile settings (Withdraws)</h3>

                  <FormItem label={"Account_todebit_onwithdraw"}>
                      <Select 
                      placeholder="Account" 
                      style={{  }} 
                      value={this.state.account_todebit_onwithdraw}
                      onChange={(val)=>{this.setState({account_todebit_onwithdraw:val})}} 
                      showSearch
                      optionFilterProp="children"
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      onSearch={this.onSearch}                    
                      >
                        {this.state.companyaccounts.map(
                          (accnt)=>(
                            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
                          ))}
                      </Select>
                  </FormItem>

                  <FormItem label={"Account_tocredit_onwithdrawcharge"}>
                      <Select 
                      placeholder="Account" 
                      style={{  }} 
                      value={this.state.account_tocredit_onwithdrawcharge}
                      onChange={(val)=>{this.setState({account_tocredit_onwithdrawcharge:val})}} 
                      showSearch
                      optionFilterProp="children"
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      onSearch={this.onSearch}                    
                      >
                        {this.state.companyaccounts.map(
                          (accnt)=>(
                            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
                          ))}
                      </Select>
                  </FormItem>


                  <FormItem label={"Account to credit on withdrawbankcharge payable"}>
                      <Select 
                      placeholder="Account" 
                      style={{  }} 
                      value={this.state.account_tocredit_onwithdrawbankcharge}
                      onChange={(val)=>{this.setState({account_tocredit_onwithdrawbankcharge:val})}} 
                      showSearch
                      optionFilterProp="children"
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      onSearch={this.onSearch}                    
                      >
                        {this.state.companyaccounts.map(
                          (accnt)=>(
                            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
                          ))}
                      </Select>
                  </FormItem>


                  <FormItem label={"Default account for savingswithdraw crediting"}>
                      <Select 
                      placeholder="Account" 
                      style={{  }} 
                      value={this.state.defaultaccount_for_savingswithdraw_crediting}
                      onChange={(val)=>{this.setState({defaultaccount_for_savingswithdraw_crediting:val})}} 
                      showSearch
                      optionFilterProp="children"
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      onSearch={this.onSearch}                    
                      >
                        {this.state.companyaccounts.map(
                          (accnt)=>(
                            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
                          ))}
                      </Select>
                  </FormItem>

                  <FormItem label={"Default account for loan disbirsement crediting"}>
                      <Select 
                      placeholder="Account" 
                      style={{  }} 
                      value={this.state.defaultaccount_for_loanissuance_crediting}
                      onChange={(val)=>{this.setState({defaultaccount_for_loanissuance_crediting:val})}} 
                      showSearch
                      optionFilterProp="children"
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      onSearch={this.onSearch}                    
                      >
                        {this.state.companyaccounts.map(
                          (accnt)=>(
                            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
                          ))}
                      </Select>
                  </FormItem>


                  

                  <h3>Savings interest</h3>
                  <FormItem label={"Account_tocredit_onossavings_interest_payable"}>
                      <Select 
                      placeholder="Account" 
                      style={{  }} 
                      value={this.state.account_tocredit_onossavings_interest_payable}
                      onChange={(val)=>{this.setState({account_tocredit_onossavings_interest_payable:val})}} 
                      showSearch
                      optionFilterProp="children"
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      onSearch={this.onSearch}                    
                      >
                        {this.state.companyaccounts.map(
                          (accnt)=>(
                            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
                          ))}
                      </Select>
                  </FormItem>

                  <FormItem label={"Account_tocredit_onossavings_interest_expense"}>
                      <Select 
                      placeholder="Account" 
                      style={{  }} 
                      value={this.state.account_tocredit_onossavings_interest_expense}
                      onChange={(val)=>{this.setState({account_tocredit_onossavings_interest_expense:val})}} 
                      showSearch
                      optionFilterProp="children"
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      onSearch={this.onSearch}                    
                      >
                        {this.state.companyaccounts.map(
                          (accnt)=>(
                            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
                          ))}
                      </Select>
                  </FormItem>

                  <FormItem label={"Account_for_savingsinterest_taxes"}>
                      <Select 
                      placeholder="Account" 
                      style={{  }} 
                      value={this.state.account_for_savingsinterest_taxes}
                      onChange={(val)=>{this.setState({account_for_savingsinterest_taxes:val})}} 
                      showSearch
                      optionFilterProp="children"
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      onSearch={this.onSearch}                    
                      >
                        {this.state.companyaccounts.map(
                          (accnt)=>(
                            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
                          ))}
                      </Select>
                  </FormItem>

                  <h3>Fixed deposit interest</h3>
                  <FormItem label={"Account_tocredit_fixeddepositsavings_interest_payable"}>
                      <Select 
                      placeholder="Account_tocredit_fixeddepositsavings_interest_payable" 
                      style={{  }} 
                      value={this.state.account_tocredit_fixeddepositsavings_interest_payable}
                      onChange={(val)=>{this.setState({account_tocredit_fixeddepositsavings_interest_payable:val})}} 
                      showSearch
                      optionFilterProp="children"
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      onSearch={this.onSearch}                    
                      >
                        {this.state.companyaccounts.map(
                          (accnt)=>(
                            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
                          ))}
                      </Select>
                  </FormItem>


                  <FormItem label={"Account_tocredit_fixeddepositsavings_interest_expense"}>
                      <Select 
                      placeholder="Account_tocredit_fixeddepositsavings_interest_expense" 
                      style={{  }} 
                      value={this.state.account_tocredit_fixeddepositsavings_interest_expense}
                      onChange={(val)=>{this.setState({account_tocredit_fixeddepositsavings_interest_expense:val})}} 
                      showSearch
                      optionFilterProp="children"
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      onSearch={this.onSearch}                    
                      >
                        {this.state.companyaccounts.map(
                          (accnt)=>(
                            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
                          ))}
                      </Select>
                  </FormItem>


                  <FormItem label={"Account_for_fixeddepositinterest_taxes"}>
                      <Select 
                      placeholder="account_for_fixeddepositinterest_taxes" 
                      style={{  }} 
                      value={this.state.account_for_fixeddepositinterest_taxes}
                      onChange={(val)=>{this.setState({account_for_fixeddepositinterest_taxes:val})}} 
                      showSearch
                      optionFilterProp="children"
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      onSearch={this.onSearch}                    
                      >
                        {this.state.companyaccounts.map(
                          (accnt)=>(
                            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
                          ))}
                      </Select>
                  </FormItem>

                  <h3>Dividends Accounts</h3>
           
                    <FormItem label={"Account_fordividend_payable"}>
                      <Select 
                      placeholder="account_fordividend_payable" 
                      style={{  }} 
                      value={this.state.account_fordividend_payable}
                      onChange={(val)=>{this.setState({account_fordividend_payable:val})}} 
                      showSearch
                      optionFilterProp="children"
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      onSearch={this.onSearch}                    
                      >
                        {this.state.companyaccounts.map(
                          (accnt)=>(
                            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
                          ))}
                      </Select>
                  </FormItem>

                  <FormItem label={"Account_for_retained_earnings"}>
                      <Select 
                      placeholder="account_for_retained_earnings" 
                      style={{  }} 
                      value={this.state.account_for_retained_earnings}
                      onChange={(val)=>{this.setState({account_for_retained_earnings:val})}} 
                      showSearch
                      optionFilterProp="children"
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      onSearch={this.onSearch}                    
                      >
                        {this.state.companyaccounts.map(
                          (accnt)=>(
                            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
                          ))}
                      </Select>
                  </FormItem>


                  <FormItem label={"Account_for_dividend_taxes"}>
                      <Select 
                      placeholder="account_for_dividend_taxes" 
                      style={{  }} 
                      value={this.state.account_for_dividend_taxes}
                      onChange={(val)=>{this.setState({account_for_dividend_taxes:val})}} 
                      showSearch
                      optionFilterProp="children"
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      onSearch={this.onSearch}                    
                      >
                        {this.state.companyaccounts.map(
                          (accnt)=>(
                            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
                          ))}
                      </Select>
                  </FormItem>

                  <h3>Sms</h3>
                  <FormItem name="usesms" label="use sms?" >
                    <Switch
                        checked={this.state.usesms}
                        onChange={val=>{this.setState({usesms:!this.state.usesms})}}
                        checkedChildren="ON"
                        unCheckedChildren="OFF"
                        />
                  </FormItem>

                  <FormItem name="send_member_welcome_message" label="Send welcome sms message?" >
                    <Switch
                        checked={this.state.send_member_welcome_message}
                        onChange={val=>{this.setState({send_member_welcome_message:!this.state.send_member_welcome_message})}}
                        checkedChildren="ON"
                        unCheckedChildren="OFF"
                        />
                  </FormItem>


                  <h3>Salary settings</h3>
                  <FormItem name="nssf_enabled" label="NSSF_enabled?" >
                    <Switch
                        checked={this.state.nssf_enabled}
                        onChange={val=>{this.setState({nssf_enabled:!this.state.nssf_enabled})}}
                        checkedChildren="ON"
                        unCheckedChildren="OFF"
                        />
                  </FormItem>

                
                     <FormItem label="nssf staff percentage">
                        <Input name="nssfstaffpercentage"   placeholder="nssfstaffpercentage" value={this.state.nssfstaffpercentage} onChange={(val)=>{this.setState({nssfstaffpercentage:val.target.value})}} />
                     </FormItem> 

                     <FormItem label="nssf company percentage">
                        <Input name="nssfcompanypercentage"   placeholder="nssfcompanypercentage" value={this.state.nssfcompanypercentage} onChange={(val)=>{this.setState({nssfcompanypercentage:val.target.value})}} />
                     </FormItem> 

                     <FormItem label={"nssf liability account"}>
                      <Select 
                      placeholder="nssfliabilityaccount" 
                      style={{  }} 
                      value={this.state.nssfliabilityaccount}
                      onChange={(val)=>{this.setState({nssfliabilityaccount:val})}} 
                      showSearch
                      optionFilterProp="children"
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      onSearch={this.onSearch}                    
                      >
                        {this.state.companyaccounts.map(
                          (accnt)=>(
                            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
                          ))}
                      </Select>
                  </FormItem>


                  <FormItem label={"salary expense account"}>
                      <Select 
                      placeholder="salary_expenseaccount" 
                      style={{  }} 
                      value={this.state.salary_expenseaccount}
                      onChange={(val)=>{this.setState({salary_expenseaccount:val})}} 
                      showSearch
                      optionFilterProp="children"
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      onSearch={this.onSearch}                    
                      >
                        {this.state.companyaccounts.map(
                          (accnt)=>(
                            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
                          ))}
                      </Select>
                  </FormItem>

                 

            <h3>Mobile money settings</h3>
            <FormItem label={"Account for mobile money collection debit"}>
                      <Select 
                      placeholder="account_for_mobilemoneycollection_debiting" 
                      style={{  }} 
                      value={this.state.account_for_mobilemoneycollection_debiting}
                      onChange={(val)=>{this.setState({account_for_mobilemoneycollection_debiting:val})}} 
                      showSearch
                      optionFilterProp="children"
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      onSearch={this.onSearch}                    
                      >
                        {this.state.companyaccounts.map(
                          (accnt)=>(
                            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
                          ))}
                      </Select>
                  </FormItem>


                  <h3>Mobile Application settings</h3>
                     <FormItem label={"Account for mobile app collection debit"}>
                      <Select 
                      placeholder="account_for_appcollection_debiting" 
                      style={{  }} 
                      value={this.state.account_for_appcollection_debiting}
                      onChange={(val)=>{this.setState({account_for_appcollection_debiting:val})}} 
                      showSearch
                      optionFilterProp="children"
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      onSearch={this.onSearch}                    
                      >
                        {this.state.companyaccounts.map(
                          (accnt)=>(
                            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
                          ))}
                      </Select>
                  </FormItem>

                 <h3>Loan Autopayments (On mobileApp deposits)</h3>   
                 <FormItem name="Automated_savingstransfer_toloan" label="Automated_savingstransfer_toloan?" >
                    <Switch
                        checked={this.state.automated_savingstransfer_toloan}
                        onChange={val=>{this.setState({automated_savingstransfer_toloan:!this.state.automated_savingstransfer_toloan})}}
                        checkedChildren="ON"
                        unCheckedChildren="OFF"
                        />
                  </FormItem>        


                 <FormItem label={"Automated_savingstransfer_toloan_interestprinciple_priority"}>
                      <Select 
                      placeholder="automated_savingstransfer_toloan_interestprinciple_priority" 
                      style={{  }} 
                      value={this.state.automated_savingstransfer_toloan_interestprinciple_priority}
                      onChange={(val)=>{this.setState({automated_savingstransfer_toloan_interestprinciple_priority:val})}} 
                      showSearch
                      optionFilterProp="children"
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      onSearch={this.onSearch}>
                            <Option value={'interest'}>Interest</Option>
                            <Option value={'principle'}>Principle</Option>
                      </Select>
                </FormItem>


                <h3>Acummulative dividends settings</h3>   
                <FormItem name="accumulated_dividends_active" label="Accumulated dividends active?" >
                    <Switch
                        checked={this.state.accumulated_dividends_active}
                        onChange={val=>{this.setState({accumulated_dividends_active:!this.state.accumulated_dividends_active})}}
                        checkedChildren="ON"
                        unCheckedChildren="OFF"
                        />
                  </FormItem>  

                  <FormItem label={"Accumulated_dividends_crediting_account"}>
                      <Select 
                      placeholder="Accumulated_dividends_crediting_account" 
                      style={{  }} 
                      value={this.state.accumulated_dividends_crediting_account}
                      onChange={(val)=>{this.setState({accumulated_dividends_crediting_account:val})}} 
                      showSearch
                      optionFilterProp="children"
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      onSearch={this.onSearch}                    
                      >
                        {this.state.companyaccounts.map(
                          (accnt)=>(
                            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
                          ))}
                      </Select>
                  </FormItem>


                  <h3>Default reports currency</h3>  

                  <FormItem label="Default Currency">
                    <Select  name="currency"
                     placeholder="Currency" 
                     value={this.state.default_report_currency} 
                     onChange={(val)=>{this.setState({default_report_currency:val})}} >

                    {
                    this.state.currencies.map((item)=>{
                      return (<Option  value={item.currency_name}>{item.currency_name}</Option>)
                    })
                   }

                    </Select>
                 </FormItem>


               <Divider></Divider>
                <FormItem label={"Data entry date cap (" +this.state.dataentry_date_cap+" )"} >
                  <DatePicker onChange={(date, dateString) => this.setState({ dataentry_date_cap: dateString})} format={dateFormat} />
                </FormItem>


                  <FormItem>
                      <Button type="primary" htmlType="submit" >Update Profile</Button>
                  </FormItem>
                  
               </Form>
          </Card>
          }
          



                  </TabPane>

                  <TabPane tab="Special settings" key="002" >
                    <CompanyProfile_autosettings />

                  </TabPane>

                  <TabPane tab="Member balances ledger map" key="003" >
                    <MemberSubaccountLedgerSettings />
                  </TabPane>
            </Tabs>

          </div>
      )}
       
    }
}

export default CompanyProfile; 